export const cleanUrl = (str: string): string | null => {
  try {
    const hasProtocol = str.startsWith('http://') || str.startsWith('https://')
    const fullString = hasProtocol ? str : 'https://' + str
    const url = new URL(fullString)

    const hostnameParts = url.hostname.split('.')
    const tld = hostnameParts[hostnameParts.length - 1]

    // Valid domain must have at least one dot and a TLD with at least 2 characters
    if (hostnameParts.length >= 2 && /^[a-z]{2,}$/i.test(tld)) {
      return fullString
    }
    return null
  } catch (_) {
    return null
  }
}
